<template>
  <div :class="[$route.name?.includes('Summary') ? 'in-summary' : '']">
    <TopBar />
    <router-view v-slot="{ Component }">
      <component :is="Component" :key="$route.fullPath" />
    </router-view>
    <BottomBar />
  </div>
</template>

<script setup>
import TopBar from "@/components/TopBar";
import BottomBar from "@/components/BottomBar";
import axios from "axios";
import { useStore } from "vuex";
import PlanStyle from "@/components/PlanStyle";
const store = useStore();
SatisfiApp.Global.chatButtonHide();
axios
  .get(
    `${store.state.API_URL}/collections/get/Styles?&populate=1&token=${store.state.API_TOKEN}`
  )
  .then(onGetPlans);

function onGetPlans(response) {
  SatisfiApp.Global.chatButtonHide();
  if (response.status === 200) {
    console.log(response.data.entries)
    store.commit("setPlans", response.data.entries);
  }
}
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
<style lang="scss">
.satisfi_chat-button {
  display:none !important;
}
@media (max-width:500px) {
.d3-o-header__branded-header .img-responsive {
  width:100%;
  object-fit: contain;
}  
}

@font-face {
  font-family: "United Sans Cd Md";
  src: url("~@/assets/fonts/UnitedSansCond-Medium.woff2") format("woff2"),
    url("~@/assets/fonts/UnitedSansCond-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "United Sans Cd Hv";
  src: url("~@/assets/fonts/UnitedSansCond-Heavy.woff2") format("woff2"),
    url("~@/assets/fonts/UnitedSansCond-Heavy.woff") format("woff");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "United Sans SmCd";
  src: url("~@/assets/fonts/UnitedSansSemiCond-Medium.woff2") format("woff2"),
    url("~@/assets/fonts/UnitedSansSemiCond-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "United Sans SmCd Hv";
  src: url("~@/assets/fonts/UnitedSansSemiCond-Heavy.woff2") format("woff2"),
    url("~@/assets/fonts/UnitedSansSemiCond-Heavy.woff") format("woff");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "United Sans Cd Bd";
  src: url("~@/assets/fonts/UnitedSansCond-Bold.woff2") format("woff2"),
    url("~@/assets/fonts/UnitedSansCond-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "United Sans Ex Hv";
  src: url("~@/assets/fonts/UnitedSansExt-Heavy.woff2") format("woff2"),
    url("~@/assets/fonts/UnitedSansExt-Heavy.woff") format("woff");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "PF DinDisplay Pro";
  src: url("~@/assets/fonts/PFDinDisplayPro-Medium.woff2") format("woff2"),
    url("~@/assets/fonts/PFDinDisplayPro-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
body {
    background-color: #0076B6;
}
a {
  text-decoration: none;
}
p {
  margin:0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  padding-bottom: 45px;
  position: relative;
  > div:before {
    content: "";
    opacity: 1;
    background-image: url("~@/assets/images/main-background.jpg");
    background-size: cover;
    background-position: top left;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index:-1;
    transition: opacity 0.6s;
  }
  .in-summary:before {
    opacity: 0.35;
  }
  > div {
    position: relative;
    > section {
    padding-top: 45px;
    }
  }
}
body {
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #54585a;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #bbb;
  }
}
</style>

